var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { QuestionScore } from '../../../classes/question/modules/QuestionScore';
export class CycleEndScore extends QuestionScore {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get maxPoints() {
        return 1;
    }
    get reachedPoints() {
        return 1;
    }
    get progressiveReachablePoints() {
        return 0;
    }
    get shouldSetCompletedTimestamp() {
        return false; // save reward seen is done by CycleDotCycleEnd_
    }
    get legacyEvalText() {
        return '';
    }
    set legacyEvalText(t) { }
}
__decorate([
    override
], CycleEndScore.prototype, "maxPoints", null);
__decorate([
    override
], CycleEndScore.prototype, "reachedPoints", null);
__decorate([
    override
], CycleEndScore.prototype, "progressiveReachablePoints", null);
__decorate([
    override
], CycleEndScore.prototype, "shouldSetCompletedTimestamp", null);
